var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",class:_vm.variant,style:({ '--height': _vm.height, width: _vm.width }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }